module.exports = __webpack_public_path__ + "img/fbtc.3a696e18.jpg";